module.exports = __webpack_public_path__ + "img/cluster_shelter_100px_bluebox.95c4682d.png";